import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger, gsap} from "../LibrariesImport";
export default class PageDivision {
	static init() {

		if( !document.body.classList.contains('post-type-archive-expertise') ){
			return;
		}

        this.numbersContainers = document.querySelectorAll('.division-col-numbers');
        this.divisions = document.querySelector('.division-text-container');
		this.numbers = document.querySelectorAll('.division-col-numbers .numbers');
		this.images = document.querySelectorAll('.division-col-numbers .shape-animation');
		this.number = document.querySelectorAll('.division-col-numbers .number');
        this.subNavContainer = document.querySelector('.archive-division-subnav');
		this.subNav = document.querySelectorAll('.archive-division-subnav .division-filter-tag');
		const division = document.querySelectorAll('.division-item');

        if (this.subNavContainer) {
            this.subnavHeight();
            GlobalVariables.resizeCallbacks.push(this);
        }

		division.forEach( (item, index) => {
			ScrollTrigger.create({
				trigger: item,
				start: "top 30%",
				onEnter: () => {
					this.currentNumber = index;
					this.changeNumber();
					this.changeImage();
				},
				onLeaveBack: () => {
					this.currentNumber = index - 1;
					if( this.currentNumber > -1 ) {
						this.changeNumber();
						this.changeImage();
					} else {
						this.subNav.forEach( (nav, i) => {
							nav.classList.remove('current');
						});
					}
				}
			});
		});
	}

    static subnavHeight() {
        const subnavHeight = this.subNavContainer.offsetHeight;
        this.numbersContainers.forEach((item) => {
            item.style = "--subnav-height: " + subnavHeight + "px;";
        });

        this.divisions.style = "--scroll-margin-top: " + subnavHeight + "px;";
    }

	static changeImage(){
		this.images.forEach( (image, i) => {
			image.classList.remove('active');
			if( i === this.currentNumber ) {
				image.classList.add('active');
			}
            gsap.to(image, 0.45, {
                yPercent: -100 * this.currentNumber,
                overwrite: true
            });
		});
	}

	static changeNumber(){
		const color = this.number[ this.currentNumber ].dataset.color;
		gsap.set( this.numbers, {
			'--alt-color' : color
		});
		this.number.forEach( (num, i) => {
			gsap.to(num, 0.3, {
				yPercent: -100 * this.currentNumber,
				overwrite: true
			});
		});
		this.subNav.forEach( (nav, i) => {
			nav.classList.remove('current');
			if( i === this.currentNumber ){
				nav.classList.add('current');
			}
		});
	}

    static resize() {
        if (this.subNavContainer) {
            this.subnavHeight();
        }
    }
}
